import Http from "@/services/api.service";
import { service_url } from "@/services/config";

const BASE = `${service_url}/api/v1`;

export function getNetworks(filter?: string) {
    return Http._axios({
        url: `${BASE}/networks/${filter ? `?${filter}` : ''}`,
        method: "get",
    });
}

export function getNetwork(id: number) {
    return Http._axios({
        url: `${BASE}/networks/${id}/`,
        method: "get",
    });
}

export function createNetwork(data: any) {
    return Http._axios({
        url: `${BASE}/networks/create/`,
        method: "post",
        data,
    });
}

export function updateNetwork(id: number, data: any) {
    return Http._axios({
        url: `${BASE}/networks/${id}/update/`,
        method: "patch",
        data,
    });
}

export function deleteNetwork(id: number) {
    return Http._axios({
        url: `${BASE}/networks/${id}/delete/`,
        method: "delete",
    });
}

// --- Mappings ---

export function getMappings(filter?: string) {
    return Http._axios({
        url: `${BASE}/mappings/${filter ? `?${filter}` : ''}`,
        method: "get",
    });
}

export function getMapping(id: number) {
    return Http._axios({
        url: `${BASE}/mappings/${id}/`,
        method: "get",
    });
}

export function createMapping(data: any) {
    return Http._axios({
        url: `${BASE}/mappings/create/`,
        method: "post",
        data,
    });
}

export function updateMapping(id: number, data: any) {
    return Http._axios({
        url: `${BASE}/mappings/${id}/update/`,
        method: "patch",
        data,
    });
}

export function deleteMapping(id: number) {
    return Http._axios({
        url: `${BASE}/mappings/${id}/delete/`,
        method: "delete",
    });
}
